export default "__VITE_ASSET__a6a41f81__"